import { z } from 'zod';
import { UserProfileSchema, OAuthProviderSchema } from './user';
/**
 * Login credentials schema
 */
export const LoginSchema = z.object({
    email: z.string().email('Invalid email format'),
    password: z.string().min(1, 'Password is required'),
});
/**
 * Registration schema (extends CreateUser with password confirmation)
 */
export const RegisterSchema = z
    .object({
    email: z.string().email('Invalid email format'),
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number'),
    confirmPassword: z.string(),
    name: z.string().min(2, 'Name must be at least 2 characters').max(100),
})
    .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});
/**
 * OAuth login/register schema
 */
export const OAuthLoginSchema = z.object({
    provider: OAuthProviderSchema,
    idToken: z.string().min(1, 'ID token is required'),
    accessToken: z.string().optional(),
});
/**
 * Token pair schema (access + refresh)
 */
export const TokenPairSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresIn: z.number().int().positive(),
    tokenType: z.literal('Bearer').default('Bearer'),
});
/**
 * Refresh token request schema
 */
export const RefreshTokenSchema = z.object({
    refreshToken: z.string().min(1, 'Refresh token is required'),
});
/**
 * Auth response (user + tokens)
 */
export const AuthResponseSchema = z.object({
    user: UserProfileSchema,
    tokens: TokenPairSchema,
});
/**
 * Password reset request schema
 */
export const ForgotPasswordSchema = z.object({
    email: z.string().email('Invalid email format'),
});
/**
 * Password reset schema
 */
export const ResetPasswordSchema = z
    .object({
    token: z.string().min(1, 'Reset token is required'),
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number'),
    confirmPassword: z.string(),
})
    .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});
/**
 * Change password schema (for logged-in users)
 */
export const ChangePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number'),
    confirmPassword: z.string(),
})
    .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});
/**
 * E-posta değiştirme (oturum açmış kullanıcı kendi hesabı için).
 * Kimlik doğrulaması olarak MEVCUT ŞİFRE istenir — sadece oturum çerezi
 * yeterli sayılmaz; oturumu ele geçiren biri hesabı devralamasın.
 */
export const ChangeEmailSchema = z.object({
    newEmail: z.string().email('Geçerli bir e-posta adresi girin').max(255),
    currentPassword: z.string().min(1, 'Current password is required'),
});
/**
 * Verify email schema
 */
export const VerifyEmailSchema = z.object({
    token: z.string().min(1, 'Verification token is required'),
});
//# sourceMappingURL=auth.js.map